import { ChevronDownIcon } from '@chakra-ui/icons';
import { Button, useDisclosure, Grid, Text } from '@chakra-ui/react';
import React, { FC } from 'react';

import { useRouterIntentState } from '@app/state/routerIntentStore';
import { TokensPair } from '@app/components/TokensPair';
import { SelectPoolModal } from '@app/screens/router-intent/components/SelectPool/SelectPoolModal';

export const SelectPool: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { sourceNetwork, targetPool } = useRouterIntentState();

  return (
    <>
      <Button
        onClick={onOpen}
        minWidth={['110px', '160px']}
        width="fit-content"
        h="100%"
        bg="transparent"
        _hover={{
          background: 'transparent'
        }}
        px={0}
        py="4px"
        borderRadius={4}
        sx={{ cursor: 'pointer' }}
      >
        <Grid
          gridTemplateColumns="70px 1fr 24px"
          gridColumnGap="6px"
          gridRowGap={0}
          w="100%"
          alignItems="center"
        >
          <TokensPair
            token0Symbol={targetPool?.token0.symbol ?? ''}
            token1Symbol={targetPool?.token1.symbol ?? ''}
          />
          <Text
            fontSize="14px"
            fontWeight="500"
            lineHeight="20px"
            color="neutral.200"
            textAlign="left"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {targetPool
              ? `${targetPool.token0.symbol} - ${targetPool.token1.symbol}`
              : 'Select pool'}
          </Text>
          <ChevronDownIcon />
        </Grid>
      </Button>
      <SelectPoolModal onClose={onClose} isOpen={isOpen} />
    </>
  );
};
